import { observer } from "mobx-react";
import _ from "lodash";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useStores } from "../../stores/root-store";
import AllergenListing from "./allergens-listing";
import AllergenForm from "./allergens-form";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ManageAllergens = observer(() => {
  const { allergenStore } = useStores();
  const { editAllergen, setEditAllergen } = allergenStore;
  const [showAllergenForm, setShowAllergenForm] = useState(false);

  const handleAllergenFormClose = (show: boolean) => {
    setShowAllergenForm(show);
    if (!show) setEditAllergen(null);
  };

  useEffect(() => {
    if (editAllergen) setShowAllergenForm(editAllergen.allergenId > 0);
  }, [editAllergen]);

  return (
    <div className="container mt-3 pb-3">
      <div className="row mb-3">
        <h5 className="mb-0 text-start">
          Allergens
          <Button
            onClick={() => setShowAllergenForm(true)}
            className="btn-default float-end"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            New
          </Button>
        </h5>
      </div>
      <AllergenListing />
      {showAllergenForm && (
        <AllergenForm
          show={showAllergenForm}
          setShowModal={handleAllergenFormClose}
        />
      )}
    </div>
  );
});

export default ManageAllergens;
